module.exports = __webpack_public_path__ + "static/media/ArcoIris3.f31707e1.jpeg";